import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import NextPrev from './NextPrev';
import {QUESTION} from '../services/Questions';
import Check from './Check';
import Loader from './Loader';
import '../assets/css/question.css';
import '../assets/css/custom.css';
import SimpleReactValidator from 'simple-react-validator';
import {CONFIG,URLS, isTrueOrFalse,makeProfileSummary,encryptPHI,decryptPHI} from "../helpers/Common"; 
import 'annotorious/css/annotorious.css';
import 'annotorious';
import $ from 'jquery';

let complain
class Questions extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            questionData:'',
            totalQuestion:0,
            currentQuestionIndex:0,
            currentQuestion:'',
            currentQuestionOption:'',
            currentQuestionAnswer:'',
            questionAnswers: new Array(),
            updateQuestionAnswers: new Array(),
            complainDetails:this.props.getComplainData.complainTypeDetails,
            nextStep:5,
            prevStep:this.props.getComplainData.complainTypeDetails.image_front !=='' ? 3 : this.props.prev,
            is_multiselect:false,
            prefix:'',
            postfix:'',
            checkedItems: new Map(),
            prevQuestionIndexes: [],
            isLoading : true,
            showInput : 0,
            optionInputFields : new Array(),
            profileData: new Array(),
            boxesArray:[],
            imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
            selectedBoxesFiltered:[],
            narrativeData:new Array(),
            resetNarrativeData:false,
            alertCheck : false,
            isModify: this.props.isModify,
            isAllOptionSelected: true,
            getComplainStack: this.props.getComplainStack,
            addNarrativeStep: 2,
            allComplains:[],
            narrativeSummary: "",



        };
        // this.nextQuestion               = this.updateNextQuestion.bind(this);
        this.addCurrentOptionAnswers    = this.addCurrentOptionAnswers.bind(this);
        this.updateNextQuestion         = this.updateNextQuestion.bind(this);
        this.handlePrevAction           = this.handlePrevAction.bind(this);
        this.makeProfileSummary     = makeProfileSummary.bind(this);

        this.validator = new SimpleReactValidator();

    }

    componentWillMount()
    {
        // console.log('Question recieve Location Data as:',this.props.getComplainLocationData)
        var complainStack = this.state.getComplainStack;
        // console.log('get complainStack here in Component will mount',complainStack); 

        if (complainStack.length > 0) {
            this.props.setComplainStack(null,'delete');
            
        }
        if(this.props.getComplainData.complainTypeDetails.image_front ===''){
            localStorage.setItem('saveQuest',true);
        }
    
        //Get data from API's
        this.setState({
            profileData:this.props.getProfileData
        })
        complain=this.state.complainDetails
        let QuestionsData = QUESTION.getQuestionsByComplainType(this.state.complainDetails.id).then(res => {
        // console.log('Under Component will mount API hits')
            
            if(res.data.header.error==0)
            {


                //Set Question Data
                this.setState({
                    questionData: res.data.body.details,
                    isLoading: false,
                    resetNarrativeData:true
                });
                // console.log('After API hit data ',res.data.body.details)
                this.setState({
                    totalQuestion: this.state.questionData.length,
                });
                // console.log('current flag ',this.state.resetNarrativeData)
                
                //Extract 1st Question a/c to paren_question_id = 0
                var ref = this;
                Object.values(res.data.body.details).forEach(function(row,key) 
                {   
                    let branchingData = row.branchingQuestionData;
                    if(branchingData.length === 0)
                    {
                        //_narrativeData = [];
                        let index = new Array();
                        index.push(key);
                        let multiSelect = (row.is_multiselect==1) ? true:false;
                        let myprefix = row.prefix;
                        let mypostfix = row.post;
                        const boxesArray=[];

                        if(row.is_image==="image_only"){

                            Object.values(row.options).forEach((item,key)=>{
                                if(item.image_options!==null){
                                boxesArray.push(item.image_options);
                                }

                            })
                        }

                        //Set 1st Question , Question Options,Current Question Index 
                        ref.setState({
                            currentQuestion: row,
                            currentQuestionOption: row.options,
                            is_multiselect:multiSelect,
                            single_line_text:row.single_line_text,
                            prevQuestionIndexes : index,
                            currentQuestionIndex:key,
                            prefix:myprefix,
                            postfix:mypostfix,
                            is_image:row.is_image,
                            boxesArray
                        });
                    }

                })

                //Set states If user comes from in-complate narrative/update 

                this.setState({
                    checkedItems: this.props.checkedItems,//default checked items
                    questionAnswers : this.props.questionAnswersData,//question answers of last complain types
                    optionInputFields : this.props.optionInputFields,//question option inputs fields text of last complain types
                    showInput : this.props.showInput,//question option inputs fields show of last complain types
                  });

                
                if(localStorage.getItem("data")){

                    var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data")); 

                    let data=JSON.parse(decryptedData);
                    // console.log('All question local data',data)
                    // console.log('this.props.getComplainData.complain_types',this.props.getComplainData.complain_types)
                    // console.log('API questionData',this.state.questionData)
                    Object.values(data).forEach((item,key)=>{

                        if(parseInt(this.props.getComplainData.complain_types) === parseInt(item.complain_type)){

                          

                            let _questionAnswersMappedWithIndexes=[];
                            let _allCamplainAnswers=item.optionData;

                            Object.values(_allCamplainAnswers).forEach((innerItem,innerKey)=>{

                                Object.values(this.state.questionData).forEach((innerInnerItem,innerInnerKey)=>{

                                    if(Array.isArray(innerItem)){

                                        if(innerItem[0].question_id === innerInnerItem.id){
                                            _questionAnswersMappedWithIndexes[innerInnerKey]=innerItem;
                                        }

                                    }else{

                                        if(innerItem.question_id === innerInnerItem.id){
                                            _questionAnswersMappedWithIndexes[innerInnerKey]=innerItem;
                                        }
                                    }

                                });


                            });

                            this.props.setQuestionAnswersData(_questionAnswersMappedWithIndexes);
                            this.props.setCheckedItems(new Map(JSON.parse(item.checkedItems)));
                            // this.props.setComplainLocation(item.complainLocationData);

                            setTimeout(()=>{

                                this.setState({
                                   ...this.state,
                                    questionAnswers:this.props.questionAnswersData,
                                    checkedItems:new Map(JSON.parse(item.checkedItems))
                                });

                            },1000);

                        }

                    });
                }
                if(this.state.resetNarrativeData){
                    this.props.setNarrativeData([]);
                }
            }
            else
            {
                this.setState({
                    isLoading: false,
                });
                // alert('No Question Available');
            }
        }).catch(err => {
            this.setState({
                isLoading: false,
            });
            // alert('No Question Available');
            return err;
        });

        // if(this.state.resetNarrativeData){
        //     this.props.setNarrativeData([]);
        // }

    }
    handlePrevAction = (e)=>{
        this.props.handleNextPrevSteps(this.state.prevStep);
    }
    
    removeTags=(data,_narrativeText,single_line_text)=>
    {   
        if(single_line_text===true)
        {
            _narrativeText = data.single_line_text;
        }
       
        _narrativeText  =  _narrativeText.replace('<x>',data.required_input_text);
        _narrativeText  = this.replaceCommonTags(_narrativeText);

        if (data.required_input_text > 0 ) 
        {
            var re = /(?:^|[ ])##([a-zA-Z]+)/gm;
            var str = _narrativeText;
            var m;
            
            while ((m = re.exec(str)) != null) {
                if (m.index === re.lastIndex) {
                 re.lastIndex++;
                }
                
                _narrativeText  =  _narrativeText.replace(m[0],(data.required_input_text) > 1 ? ' '+m[1]+'s' : ' '+m[1]);

            }
        }
       
        return _narrativeText;

    }
//    remove tags 
    replaceCommonTags=(_narrativeText)=>
    {
        // _narrativeText  =  _narrativeText.replace('<title>', this.state.profileData.title);
        // _narrativeText  =  _narrativeText.replace('<name>', this.state.profileData.first_name+" "+this.state.profileData.last_name);
        // _narrativeText  =  _narrativeText.replace('<fname>', this.state.profileData.first_name);
        // _narrativeText  =  _narrativeText.replace('<lname>', this.state.profileData.last_name);
        // _narrativeText  =  _narrativeText.replace('<gender>', this.state.profileData.gender.toLowerCase());

        _narrativeText  =  _narrativeText.split('<title>').join(this.state.profileData.title);
        _narrativeText  =  _narrativeText.split('<name>').join(this.state.profileData.first_name+" "+this.state.profileData.last_name);
        _narrativeText  =  _narrativeText.split('<fname>').join(this.state.profileData.first_name);
        _narrativeText  =  _narrativeText.split('<lname>').join(this.state.profileData.last_name);
        _narrativeText  =  _narrativeText.split('<gender>').join(this.state.profileData.gender.toLowerCase());
        if(this.state.profileData.gender==='Male')
        {
            // _narrativeText  =  _narrativeText.replace('<his/her>', 'his');
            _narrativeText  =  _narrativeText.split('<his/her>').join('his');
            // _narrativeText  =  _narrativeText.replace('<he/she>', 'he');
            _narrativeText  =  _narrativeText.split('<he/she>').join('he');
        }
        else
        {
            // _narrativeText  =  _narrativeText.replace('<his/her>', 'her');
            _narrativeText  =  _narrativeText.split('<his/her>').join('her');
            // _narrativeText  =  _narrativeText.replace('<he/she>', 'she');
            _narrativeText  =  _narrativeText.split('<he/she>').join('she');


        }
        
        return _narrativeText;
    }
    updateNextQuestion()
    {
        if (this.validator.allValid()) {
            this.validator.hideMessages();
        }else{
            this.validator.showMessages();
            return false;
        }

        let questionData = this.state.questionData;
        let addQuestionInArray = true;

        let checkedItems = this.state.checkedItems;
        let _questionOptions = this.state.currentQuestionOption;
        // console.log('currentQuestion',this.state.currentQuestion)
        // console.log('checkedItems',checkedItems)
        // console.log('_questionOptions',_questionOptions)
        
        // All options to be selected if required from backend
        if (this.state.currentQuestion.is_multiselect == 1 && this.state.currentQuestion.all_multiselect_required == 1) 
        {
            var inputSum = [];
            var selectedOptions = [];
        
            Object.values(_questionOptions).forEach( (OptionsRow,OptionsKey) =>{
            
                checkedItems.forEach((row,key) => {
                
                    if (key == OptionsRow.id) {

                        if (row == true) {
                            selectedOptions.push(OptionsRow);
                            if (OptionsRow.required_input  == 1) {
                                inputSum.push(parseInt(this.state.optionInputFields[OptionsRow.id], 10));
                            
                            }
                        
                        }
                        
                    } 
                });
                
            });
            
            // console.log('inputSum',inputSum);
            // console.log('total of input foelds',inputSum.reduce((a, b) => a + b, 0));
            // console.log('total selected options',selectedOptions.length);
            if (_questionOptions.length != selectedOptions.length) {
                alert('You are required to select all the options in this question')
                return false;
            }else{
                if (inputSum.reduce((a, b) => a + b, 0) > parseInt(this.state.currentQuestion.multiselect_value_sum_limit) || inputSum.reduce((a, b) => a + b, 0) < parseInt(this.state.currentQuestion.multiselect_value_sum_limit)) {
                    alert('The total of all options should be '+ this.state.currentQuestion.multiselect_value_sum_limit)
                    return false;

                }
            }
           
        }   
        //    End

        var ref = this;
        var res = '';
        var complainStack =  this.state.getComplainStack;

        var isNonOfAbove = false;
        var totalSelected = [];
        Object.values(_questionOptions).forEach( (row,key) =>
        { 
            // console.log('here all options data',row)
            this.state.checkedItems.forEach((value,key) => {
                if (row.id == key && value == true) {
                    // console.log('all selected options',row)
                    totalSelected.push(row.id);
                    if (row.none_of_above == 1) {
                        isNonOfAbove = true;
                    }
                    if (row.is_link_to_complain == 1 && this.props.isModify !== true) 
                    {
                        this.props.setComplainStack(row.link_to_complain_type_id,'update');
                    }
            
                }
            });
            
             
            if(ref.state.checkedItems.get(row.id))
            {
                //ref.addCurrentOptionAnswers.bind(this,row.id,key,row.narrative_text,row.parent_question_id,row.required_input,row.sort_order)
                //let gender = (profileData.gender).toLowerCase(); 
                const answers                   = new Array();
                let _narrativeText  = row.narrative_text;

                if(Array.isArray(row) && isTrueOrFalse(row.is_multiselect)){
                   
                    if(row.length>1){
                      
                        let narrativeText=row[0].prefix;
                        row.forEach((item,key)=>{
                            narrativeText= narrativeText + item.narrative;

                        });

                        // narrativeText = narrativeText + row[0].postfix;

                        // _narrativeText  =  _narrativeText.replace('<x>', narrativeText );

                    }else{

                   
                       //  _narrativeText  =  _narrativeText.replace('<x>', row[0].single_line_text );
                    }

                }else{

                // _narrativeText  =  _narrativeText.replace('<x>', ref.state.optionInputFields[row.id]);

                }
                // _narrativeText  =  _narrativeText.replace('<title>', ref.state.profileData.title);
                // _narrativeText  =  _narrativeText.replace('<name>', ref.state.profileData.first_name+" "+ref.state.profileData.last_name);
                // _narrativeText  =  _narrativeText.replace('<gender>', ref.state.profileData.gender.toLowerCase());
                // if(ref.state.profileData.gender=='Male')
                // {
                //     _narrativeText  =  _narrativeText.replace('<his/her>', 'his');
                //     _narrativeText  =  _narrativeText.replace('<he/she>', 'he');
                // }
                // else
                // {
                //     _narrativeText  =  _narrativeText.replace('<his/her>', 'her');
                //     _narrativeText  =  _narrativeText.replace('<he/she>', 'she');

                // }
                this.validator.hideMessages();
                if (row.required_input  == 1 && ref.state.optionInputFields[row.id] === undefined) 
                {
                    alert('Please define.'); 
                    this.state.alertCheck = true;
                    this.validator.showMessages();
                    res = 'true';
                    return false;
                }
                
                answers.push({
                    option_id:row.id,
                    question_id:row.question_id,
                    is_multiselect:isTrueOrFalse(row.is_multiselect),
                    single_line_text:row.single_line_text,
                    prefix:ref.state.currentQuestion.prefix,
                    postfix:ref.state.currentQuestion.postfix,
                    sort_order:row.sort_order,
                    narrative_text:_narrativeText,
                    parent_question_id:row.parent_question_id,
                    required_input:row.required_input,
                    required_input_text:ref.state.optionInputFields[row.id],
                });
                if(localStorage.getItem('saveQuest')=='true')
                {

                    if(localStorage.getItem('newData')==''||localStorage.getItem('newData')==null){
                        let newData=[]
                        newData.push({complainType:complain.name,answere:answers})
                       // var encryptedNewData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(newData));
                        localStorage.setItem('newData',JSON.stringify(newData));
                        
                        localStorage.setItem('saveQuest','false')
                    }

                    else{
                        if(localStorage.getItem('editQuest')=='true')
                        {
                            let newData =localStorage.getItem('newData')
                            newData = JSON.parse(newData) 
                            // loop in local data          --> /`/ 
                            var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data")); 
                            let data=JSON.parse(decryptedData);
                            newData.forEach((element,key) => {
                                
                                if(this.state.complainDetails.name == element.complainType){
                                    newData[key]={complainType:complain.name,answere:answers}
                                    
                                }

                            });
                     // /`/ newData[newData.length-1]={complainType:complain.name,answere:answers}
                            
                            // newData.push({complainType:null,answere:answers})
                            //var encryptedNewData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(newData));
                            localStorage.setItem('newData',JSON.stringify(newData))
                             
                            localStorage.setItem('saveQuest','false')
                            localStorage.setItem('editQuest','false')
                        }
                        else{
                            let newData =localStorage.getItem('newData')
                            //var decryptedNewData = decryptPHI(CONFIG.ENCRYPTION_KEY,newData);

                            newData = JSON.parse(newData) 
                            newData.push({complainType:complain.name,answere:answers})
                           // var encryptedNewData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(newData));

                            localStorage.setItem('newData',JSON.stringify(newData))
                            localStorage.setItem('saveQuest','false')
                        }
                     
                    }
                   
                    
                }
                // newdata
                const _questionAnswers           = ref.state.questionAnswers;
                // if(answers.length > 0){
                //     _questionAnswers[ref.state.currentQuestionIndex] = answers;
                // }else{
                // _questionAnswers[ref.state.currentQuestionIndex] = answers[0];
                // }

                ref.setState({
                    questionAnswers : _questionAnswers
                });
               
            }
            
        });

        if (isNonOfAbove === true && totalSelected.length > 1) 
        {
            alert('You can not select None of the above with other options');
            return false;
        }
        //console.log('state, questionAnswers',this.state.questionAnswers)
       //Check user select any option for current question
        if(this.state.questionAnswers[this.state.currentQuestionIndex])
        {
            let currentQuestionIndex    = this.state.totalQuestion;
            let prevQuestionIndexes     = this.state.prevQuestionIndexes;
            const questionAnswers       = this.state.questionAnswers;
            const updateQuestionAnswers = this.state.updateQuestionAnswers;
            let currentQuestionAnswer   = this.state.questionAnswers[this.state.currentQuestionIndex];
            // console.log('questionAnswers',questionAnswers)
            // console.log('updateQuestionAnswers',updateQuestionAnswers)
            // console.log('currentQuestionAnswer',currentQuestionAnswer)
            // console.log('currentQuestionAnswer.required_input_text',currentQuestionAnswer.required_input_text)
            
            if (currentQuestionAnswer.required_input  == 1 && currentQuestionAnswer.required_input_text === undefined) 
            {
                if (this.state.alertCheck == false) {
                    this.validator.showMessages();
                    alert('Please define.'); 
                }
               
                return false;
            }else{
             
                let _narrativeData          = this.props.narrativeData; 
                let _ref                    = this;
                var isOnlyOption = false;
                var isMultiselect = false;
                questionAnswers.forEach(function(row,key) 
                {
                    if(key === _ref.state.currentQuestionIndex){

                        let _narrative = "";
                        if ("option_id" in row)
                        {
                            _narrative = row.narrative_text;
                            _narrative = _ref.removeTags(row,_narrative,false);
                            _narrativeData.push(_narrative)
                        }
                        else
                        {
                            isMultiselect =true;

                            if(row.length===1)
                            {
                                isOnlyOption =true;
                                _narrative = row[0].narrative_text;
                                _narrative = _ref.removeTags(row[0],_narrative,false);
                                _narrativeData.push(_narrative)
                                // console.log('single nerrative selected',_narrativeData);
                                
                            }
                            else
                            {
                                let _narrativetxt = ''
                                let multiNarrative = [];
                                row.forEach(function(item,k)
                                {
                                    _narrativetxt = item.narrative_text;
                                    _narrativetxt = _ref.removeTags(item,_narrativetxt,true);
                                    multiNarrative.push(_narrativetxt)

                                })
                                let narLength = multiNarrative.length;
                                let lastIndexNarrative = multiNarrative[narLength-1];
                                multiNarrative.pop();

                                _narrative +=multiNarrative.join(', ')+" and "+lastIndexNarrative;
                                let prefix  = "";
                                let postfix  = "";
                                if(row[0].prefix!=null)
                                {
                                    prefix      = ref.replaceCommonTags(row[0].prefix) ? ref.replaceCommonTags(row[0].prefix) : "";
                                    _narrative  = prefix+" "+_narrative;
                                }
                                // if(row[0].postfix!=null)
                                // {
                                //     postfix     = ref.replaceCommonTags(row[0].postfix) ? ref.replaceCommonTags(row[0].postfix) : "";
                                //     //_narrative  = _narrative+" "+postfix.trim();
                                //     postfix = postfix.trim();
                                //     if(postfix =='.' || postfix =='?'|| postfix =='.<br>'|| postfix =='. <br>'|| postfix =='?<br>'|| postfix =='? <br>'|| postfix =='. <br> <br>'|| postfix =='? <br> <br>'|| postfix =='.<br> <br>'|| postfix =='?<br> <br>'){
                                //         _narrative  = _narrative+postfix;
                                //     }else{
                                //         _narrative  = _narrative+" "+postfix; 

                                //     } 
                                // }

                                _narrativeData.push(_narrative)

                            }

                                // console.log('Question All narative: ',_narrative)
                        }
                    }
                
                });
                
                
                // showing Not selected options
                // console.log('this.state.currentQuestion',this.state.currentQuestion);
        
                if (this.state.currentQuestion.all_unselected_options_required_in_narative == 1) 
                {  
                    var answerSelected = [];
                    var answerNotSelected = [];
                    var conjunctionField = this.state.currentQuestion.conjunction;
                    _questionOptions.forEach( (alloptionsValue,alloptionsKey) => {
                        
                        if (Array.isArray(questionAnswers[questionAnswers.length-1])) {
                            this.state.checkedItems.forEach((value,key) => {
                                if (alloptionsValue.id == key && value == true) {
                                
                                    answerSelected.push(key);
                            
                                } else{
                                    // console.log('options not selected..',alloptionsValue);
                                    if (alloptionsValue.none_of_above !== 1) {
                                        answerNotSelected.push(alloptionsValue.id)
                                        
                                    }
                                
                                }
                            });
                        }
                    });
              
                    var final = answerNotSelected.filter(function(item) {
                    return !answerSelected.includes(item);
                    })
                    let unique = [...new Set(final)];
                    // console.log('unique',unique);
                    
                    var notSelectedAllOptions = [];
                    _questionOptions.forEach( (optionsValues,optionsKeys) => {
                        unique.forEach(element => {
                            if (optionsValues.id == element) {
                                notSelectedAllOptions.push(optionsValues.single_line_text)
                            
                            }
                        });
                    });
                   
                    let notSelectedAllOptionsLength = notSelectedAllOptions.length;
                    if (notSelectedAllOptionsLength > 0) 
                    {
                        let lastIndex = notSelectedAllOptions[notSelectedAllOptionsLength-1];
                        let secondLastIndex = notSelectedAllOptions[notSelectedAllOptionsLength-2];
                        notSelectedAllOptions.pop();
                        // console.log('lastIndex',lastIndex);
                        
                        var _optionsNotSelectedNar ='';
                        if (notSelectedAllOptionsLength == 1) {
                            _optionsNotSelectedNar +=lastIndex+'.';
                            
                        } else {
                            if (lastIndex == '<x>') {
                                notSelectedAllOptions.pop();
                                _optionsNotSelectedNar +=notSelectedAllOptions.join(', ')+" and "+secondLastIndex;
                                
                            } else {
                                _optionsNotSelectedNar +=notSelectedAllOptions.join(', ')+" and "+lastIndex;
                                
                            }
                            
                        }
                        console.log('questionAnswers',questionAnswers);
                        console.log('this.state.questionAnswers[this.state.currentQuestionIndex])',this.state.questionAnswers[this.state.currentQuestionIndex]);
                        
                        _narrativeData[_narrativeData.length-1] = _narrativeData[_narrativeData.length-1]+' '+conjunctionField+' '+_optionsNotSelectedNar;
                        
                    }
                }
                if (isMultiselect ===true) {

                    if (isOnlyOption == false) {
                        var postfix = this.state.questionAnswers[this.state.currentQuestionIndex][0].postfix;
                        if(postfix != null)
                        {
                            postfix     = ref.replaceCommonTags(postfix) ? ref.replaceCommonTags(postfix) : "";
                            //_narrative  = _narrative+" "+postfix.trim();
                            postfix = postfix.trim();
                            if(postfix =='.' || postfix =='?'|| postfix =='.<br>'|| postfix =='. <br>'|| postfix =='?<br>'|| postfix =='? <br>'|| postfix =='. <br> <br>'|| postfix =='? <br> <br>'|| postfix =='.<br> <br>'|| postfix =='?<br> <br>'){
                                _narrativeData[_narrativeData.length-1] += postfix;

                            }else{
                                _narrativeData[_narrativeData.length-1] += postfix;

                            } 
                        }
                    }else 
                    {
                        if (this.state.currentQuestion.all_unselected_options_required_in_narative == 1) {

                            _narrativeData[_narrativeData.length-1] += '.';
                            
                        }
                    }
                    
                    
                }
                // End
                this.setState({narrativeData : _narrativeData})
            
                //Check option have required input
                if(Array.isArray(this.state.questionAnswers[this.state.currentQuestionIndex])){

                    this.state.questionAnswers[this.state.currentQuestionIndex].every((item)=>{

                        //Check option have required input
                        if(item.required_input==1 )
                        {
                            if(!item.required_input_text)
                            {
                                addQuestionInArray = false;
                            }
                        }
                        if(!addQuestionInArray)
                        {
                            this.validator.showMessages();
                            alert('Please fill input field.');
                            return false;
                        }

                        return true;

                    });

                }else{

                    //Check option have required input
                    if(currentQuestionAnswer.required_input==1 )
                    {
                        if(!currentQuestionAnswer.required_input_text)
                        {
                            addQuestionInArray = false;
                        }
                    }

                }

                if(!addQuestionInArray)
                {
                    this.validator.showMessages();
                    alert('Please fill input field.');
                    return false;
                }
                else
                {
                    //const answers               = new Array();
                    //answers.push(this.state.questionAnswers[this.state.currentQuestionIndex]);
                    
                    /** updateQuestionAnswers this is only for when user update narrative */
                    updateQuestionAnswers[this.state.currentQuestionIndex] = this.state.questionAnswers[this.state.currentQuestionIndex];
                    
                    // console.log('Question All _narrativeData: ',_narrativeData) 
                    // console.log('At the end _narrativeData to update props',_narrativeData)
                    //updateQuestionAnswers.push(this.state.questionAnswers[this.state.currentQuestionIndex]);
                    this.setState({...this.state, updateQuestionAnswers : updateQuestionAnswers,narrativeData:_narrativeData , resetNarrativeData:false});
                    this.props.setNarrativeData(_narrativeData);

                    /** Extract next question option */
                    let selectedOptionId    = currentQuestionAnswer.option_id;
                    let selectedQuestionId  = currentQuestionAnswer.question_id;
                    
                    Object.values(questionData).forEach(function(row,key) 
                    {   
                        let branchingQuestionData = row.branchingQuestionData;

                        let addedToArray=false;
                        Object.values(branchingQuestionData).forEach(function(r,k)
                        {

                            /** In first Condition For Multi Select We skip to check parent question option id. We just Check parent_question in branching Logic */
                            if(ref.state.is_multiselect && r.parent_question_id == ref.state.currentQuestion.id && !addedToArray)
                            {
                                /** Extract next question index */
                                currentQuestionIndex = key;
                                prevQuestionIndexes.push(key);

                                addedToArray=true;

                            }
                            else{
                                if(
                                    r.parent_question_option_id == selectedOptionId &&
                                    r.parent_question_id        == selectedQuestionId
                                    )
                                    {
                                        /** Extract next question index */
                                        currentQuestionIndex = key;
                                        prevQuestionIndexes.push(key);
                                    }

                            }
                        });
                        
                    })
                    //let currentQuestionIndex = this.state.currentQuestionIndex+1;
                    if(currentQuestionIndex < this.state.totalQuestion)
                    {   
                        
                        this.setState({
                            prevQuestionIndexes : prevQuestionIndexes
                        })
                        /** Set next question here */
                        this.updateCurrentQuestion(currentQuestionIndex);
                    }
                    else
                    {   
                        /** SAVE ALL DATA IN MASTER COMPONENT AND GO TO PATIENT NARRATIVE*/    
                        this.props.setCheckedItems(this.state.checkedItems);
                        this.props.setOptionInputFields(this.state.optionInputFields);
                        this.props.setInputField(this.state.showInput);
                        
                        if(this.props.isNarrativeUpdate)
                        {  
                            this.props.setQuestionAnswersData(this.state.questionAnswers);
                            
                        }
                        else
                        {   
                            this.props.setQuestionAnswersData(this.state.questionAnswers);
                        }
                        // console.log('this.props.getComplainStack on question last',this.props.getComplainStack);
                        
                        if (this.state.getComplainStack.length > 0) 
                        {
                            this.setState({...this.state,allComplains:this.props.getAllComplains});

                            const patientAnswerData = this.props.getQuestionAnswersData.filter(
                            val => val
                            );
                            let profileData = this.props.getProfileData;
                            let narrativeSummary = "";

                            // Get narrative summary of latest question answers data 
                            if (!patientAnswerData)
                            {
                                this.history.push(URLS.master);
                                
                            }
                            let saveData = new Array();
                            saveData.push({
                            'optionData':patientAnswerData,
                            'complain_type':this.props.getComplainData.complain_types,
                            'complain_type_name':this.props.getComplainData.complainTypeDetails.name,
                            'complainLocationData':this.props.getComplainLocationData,
                            'surgeon_id':this.props.surgeon_id,
                            'checkedItems': JSON.stringify(Array.from(this.props.checkedItems.entries()))
                            });
                            let data = localStorage.getItem("data");

                            if(data)
                            {
                                var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,data);
                                data = JSON.parse(decryptedData);
                                // Get previous narrative summary from strage

                                let flag=false;

                                Object.values(data).forEach((item,key)=>{

                                if(parseInt(this.props.getComplainData.complain_types) === parseInt(item.complain_type)){
                                    data[key]['primary_complain']=0;
                                    data[key]=saveData[0];
                                    flag=true;
                                    }

                                });
                                // ???
                                if(!flag){

                                    saveData[0]['primary_complain']=0;
                                    // Add Question Data in Storage array
                                    data.push(saveData[0]);

                                }


                            }
                            else
                            {
                                // Add Question Data if user create 1st Complain
                                saveData[0]['primary_complain']=1;
                                data = saveData;
                            }
                        
                            // Save data into storage
                            var encryptedData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(data));
                            localStorage.setItem("data", encryptedData);
                            // Sort Summary by category order and save
                            let summryData = new Array();

                            let ref=this;
                            if(data.length>0)
                            {
                                summryData = new Array();
                                Object.values(data[data.length-1].optionData).forEach(function(row2, key) {

                                    if(Array.isArray(row2))
                                    {
                                        if(row2.length>1)
                                        {
                                            let narrativeText=row2[0].prefix +" ";
                                            row2.forEach((rowItem,key)=>
                                            {
                                                rowItem.narrative_text = rowItem.narrative_text.replace('<x>',rowItem.required_input_text);
                                                
                                                if(key === row2.length-1){

                                                    narrativeText=" " + narrativeText + " and " + rowItem.single_line_text;
                                                }else{

                                                    narrativeText=" " + narrativeText + rowItem.single_line_text;
                                                    if(key !== (row2.length)-2)
                                                    {
                                                        narrativeText=" " + narrativeText+ ", "
                                                    }
                                            
                                                }

                                            });
                                            if(row2[0].postfix == '.' || row2[0].postfix == '?' || row2[0].postfix == '.<br>'|| row2[0].postfix == '. <br>'|| row2[0].postfix == '?<br>'|| row2[0].postfix == '? <br>'|| row2[0].postfix =='. <br> <br>'|| row2[0].postfix =='? <br> <br>'|| row2[0].postfix =='.<br> <br>'|| row2[0].postfix =='?<br> <br>')
                                            {
                                                narrativeText =" " + narrativeText+row2[0].postfix;
                                            }else{
                                                narrativeText =" " + narrativeText + " "+ row2[0].postfix;
                                            }
                                            summryData.push({'narrative':narrativeText,'order':row2[0].sort_order,'id':row2[0].question_id});

                                        }else{
                                            summryData.push({'narrative':row2[0].narrative_text,'order':row2[0].sort_order,'id':row2[0].question_id});

                                        }

                                    }else {
                                        row2.narrative_text = row2.narrative_text.replace('<x>',row2.required_input_text);
                                        if(profileData.gender=='Male')
                                        {
                                            row2.narrative_text =  row2.narrative_text.replace('<his/her>', 'his');
                                        }
                                        else
                                        {
                                            row2.narrative_text =  row2.narrative_text.replace('<his/her>', 'her');
                                        }
                                        summryData.push({'narrative':row2.narrative_text,'order':row2.sort_order,'id':row2.question_id});

                                    }

                                });
                                summryData.sort((a, b) => a.order - b.order);
                                summryData.sort((a, b) => a.id - b.id);
                                Object.values(summryData).forEach(function(_row, _key)
                                {

                                    if(_key == 0)
                                    {
                                    _row.narrative = '';
                                    }
                                    //console.log('row: ',_row)
                                    narrativeSummary += _row.narrative+" ";
                                });
                                // Add spacing between complains
                                narrativeSummary +="<br><br><br>"
                                //summryData.push({'narrative':'</br></br>'});

                            }


                            let {_profileSummary,image_and_points} = makeProfileSummary(profileData,data);
                            _profileSummary = _profileSummary.replace('neck and arm pain','neck pain');
                            let myNarrativeData="";
                            Object.values(this.props.narrativeData).forEach((item,key)=>{
                                if(key!==0){
                                    myNarrativeData+=" " + item;

                                }
                            });

                            this.setState({...this.state,allComplains:[...this.state.allComplains,{narrativeSummary: _profileSummary +"<br><br>"+narrativeSummary , image_and_points , myNarrativeData } ]});
                            
                            narrativeSummary =  narrativeSummary.replace('<title>', profileData.title);
                            narrativeSummary =  narrativeSummary.replace('<name>', profileData.first_name+" "+profileData.last_name);

                            if(profileData.gender=='Male')
                            {
                            narrativeSummary =  narrativeSummary.replace('<his/her>', 'his');
                            narrativeSummary =  narrativeSummary.replace('<he/she>', 'he');
                            }
                            else
                            {
                            narrativeSummary =  narrativeSummary.replace('<his/her>', 'her');
                            narrativeSummary =  narrativeSummary.replace('<he/she>', 'she');
                            }
                            
                            this.setState({ 
                            narrativeSummary:_profileSummary+"<br><br>"+narrativeSummary
                            });
                            this.props.setNarrativeSummary(_profileSummary+narrativeSummary);
                            this.props.setAllComplains({profileSummary: _profileSummary ,narrativeSummary: narrativeSummary , image_and_points , myNarrativeData });
                          
                            var firstCompType = [...this.state.getComplainStack].shift();
                            // console.log('firstCompType',firstCompType);
                            this.props.setQuestionAnswersData(new Array());
                            this.props.setCheckedItems(new Map());
                            this.props.handleNextPrevSteps(this.state.addNarrativeStep);
                            this.props.setSelectedComplains(this.props.getComplainData.complain_types);
                            this.props.setIsModify(false);
                            this.props.addAnotherComplain(true);
                             
                        }else
                        {

                            this.props.handleNextPrevSteps(this.state.nextStep);

                        } 
                    }
                }
            }

        }
        else
        {
            this.validator.showMessages();
            alert('please select at least one option.');
            return false;
        }

    } 
    updatePrevQuestion = (props) =>
    {   
       
        let prevQuestionIndexes = this.state.prevQuestionIndexes;
        let narrativeData           = this.state.narrativeData;
        const lastIndex         = prevQuestionIndexes[(prevQuestionIndexes.length)-1];
        prevQuestionIndexes.pop();
        narrativeData.pop();
        this.setState({
            narrativeData:narrativeData
        })
        if(prevQuestionIndexes.length > 0)
        {   
            let questionAnswers = this.state.questionAnswers;
            // delete questionAnswers[lastIndex];
            let currentQuestionIndex = prevQuestionIndexes[(prevQuestionIndexes.length)-1]
            this.setState({
                prevQuestionIndexes : prevQuestionIndexes,
                questionAnswers : questionAnswers,
                narrativeData:narrativeData
            })
            
            this.setState({
                currentQuestionIndex:currentQuestionIndex,
            });
            this.updateCurrentQuestion(currentQuestionIndex);
        }
        else
        {
            this.handlePrevAction();
        }
        // else
        // {
        //     this.setState({
        //         currentQuestionIndex:0
        //     })
        // }

        this.checkAndMarkBoxes();

    } 

    checkAndMarkBoxes=()=>{

        if(this.state.is_image==="image_only" && this.state.boxesArray.length>0){

            // window.anno.makeAnnotatable(document.getElementById('boxespic'));


            this.showPoints(this.state.boxesArray);
            if (this.state.isModify) {
                // console.log('perfect modify check')
                this.setState({...this.state,selectedBoxesFiltered:this.state.questionAnswers[this.state.currentQuestionIndex]});
            }
            $('body').on('change','.img-point',null,(event)=>{

                const option_id = event.target.value;

                Object.values(this.state.currentQuestion.options).forEach((item,key)=>{

                    if(item.image_options!==null){

                        if(item.image_options.option_id === parseInt(option_id)){


                            let flag=false;
                            let i=0;


                            for(i=0;i<this.state.selectedBoxesFiltered.length;i++){

                                if(this.state.selectedBoxesFiltered[i].id === item.id){
                                    flag=true;
                                    break;
                                }
                            }

                            if(flag){

                                let selectedBoxes=this.state.selectedBoxesFiltered.filter((innerItem,innerKey)=>{

                                    if(innerItem.id === item.id){

                                        return false;

                                    }else{

                                        return true;
                                    }

                                });

                                // this.state.questionAnswers[this.state.currentQuestionIndex]


                                this.setState({...this.state,selectedBoxesFiltered:selectedBoxes});


                                this.addCurrentOptionAnswersForBoxes(item.id,key,item.narrative_text,item.question_id,item.required_input,this.state.currentQuestion.category_order,
                                    this.state.is_multiselect,this.state.currentQuestion.prefix,this.state.currentQuestion.postfix,item.single_line_text,selectedBoxes);


                            }else{

                                let mutatedItem={...item,
                                    option_id:item.id,multiSelect:this.state.is_multiselect,
                                    single_line_text:item.single_line_text,
                                    prefix:this.state.currentQuestion.prefix,
                                    postfix:this.state.currentQuestion.postfix,
                                    question_id:item.question_id,
                                    sort_order:item.sort_order,
                                    narrative_text:item.narrative_text,
                                    parent_question_id:item.question_id,
                                    required_input:item.required_input,
                                    required_input_text:this.state.optionInputFields[item.id]
                                };

                                this.setState({...this.state,selectedBoxesFiltered:[...this.state.selectedBoxesFiltered,mutatedItem]});

                                setTimeout(()=>{

                                    this.addCurrentOptionAnswersForBoxes(item.id,key,item.narrative_text,item.question_id,item.required_input,this.state.currentQuestion.category_order,
                                        this.state.is_multiselect,this.state.currentQuestion.prefix,this.state.currentQuestion.postfix,item.single_line_text,this.state.selectedBoxesFiltered);

                                },500);

                            }

                            // let myQuestionAnswers=[...this.state.questionAnswers];

                            // console.log(myQuestionAnswers,"MyQuestionAnswers")

                        }
                    }

                });


            });


            // Object.values(this.state.boxesArray).forEach((item,key)=>{
            //
            //     console.log(item,"InnerItem");
            //
            //     let myAnnotation = {
            //         /* The URL of the image where the annotation should go */
            //         src : this.state.imgPath + item.image_src,
            //
            //         image_map_id : item.id,
            //
            //         /* The annotation text */
            //         text : item.label,
            //
            //         /* The annotation shape */
            //         shapes : [{
            //             /* The shape type */
            //             type : 'rect',
            //
            //             /* The shape geometry (relative coordinates) */
            //             geometry : { x : item.coordinate_x, y: item.coordinate_y, width :item.coordinate_width, height: item.coordinate_height }
            //         }]
            //     };
            //
            //     window.anno.addAnnotation(myAnnotation, "");
            //
            // });
            //
            // window.anno.setSelectionEnabled(false);
            // console.log(window.anno.getActiveSelector(),"ActiveSelector");
            //
            // $('body').on('click','canvas.annotorious-item-focus',null,(event)=>{
            //
            //     console.log("YAHOOO");
            //     console.log($('div.annotorious-popup').css('opacity'),"Opacity");
            //
            //     if($('div.annotorious-popup').css('opacity')==='0.9'){
            //
            //         if($('canvas.annotorious-item-focus').attr("data")==="true"){
            //             $('canvas.annotorious-item-focus').attr("data","false");
            //         }else{
            //             $('canvas.annotorious-item-focus').attr("data","true");
            //         }
            //         // $('canvas.annotorious-item-focus').addClass('tullo');
            //
            //         const label_text=$('.annotorious-popup-text').text();
            //         let option_id;
            //
            //         console.log($('.annotorious-popup-text').text());
            //
            //         this.state.boxesArray.forEach((item,key)=>{
            //
            //             if(item.label===label_text){
            //                 option_id=item.option_id;
            //             }
            //
            //         });
            //
            //         // let myQuestionAnswers=[...this.state.questionAnswers];
            //
            //     }
            //
            // })

        }

    }

    addInputTextInOptionAnswers = (e,multiSelect,optionId,originalItem)=>
    {   
        // console.log(' IN addInputTextInOptionAnswers')

        
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;
        var inputValue =    e.target.value;
        // console.log('state current questionAnswers',questionAnswers)
        if(multiSelect){

            questionAnswers[currentQuestionIndex] = questionAnswers[currentQuestionIndex].map((item)=>{


                if(optionId === item.option_id){

                    // item.required_input_text=e.target.value;
                    return {...item,required_input_text:inputValue};

                }else{
                    return item;
                }
            });


        }else{
            // console.log('else evenet value',e.target.value.trim())validation_rules
            var validation_rules = questionAnswers[currentQuestionIndex]['validation_rules']; 
            if (validation_rules != null || validation_rules != undefined) 
            {
                if(validation_rules.includes('numeric'))
                {
                    questionAnswers[currentQuestionIndex]['required_input_text'] = inputValue.trim();
                }else{
                    questionAnswers[currentQuestionIndex]['required_input_text'] = inputValue;

                }
            }else{
                questionAnswers[currentQuestionIndex]['required_input_text'] = inputValue;

            }
            
                
            
        }
        // console.log('questionAnswers[currentQuestionIndex]',questionAnswers[currentQuestionIndex])
        // console.log('e.target.value',e.target.value)
        // console.log('this.state.optionInputFields',this.state.optionInputFields)
        let inputFields = this.state.optionInputFields;
        if (validation_rules != null || validation_rules != undefined) 
            {
                if(validation_rules.includes('numeric'))
                {
                    inputFields[e.target.id] = inputValue.trim();
                }else{
                    inputFields[e.target.id] = inputValue;

                }
            }else{
                inputFields[e.target.id] = inputValue;

            }
        

        // if (e.target.value.trim() !== '') {
        //     inputFields[e.target.id] = e.target.value.trim();
        //     console.log('inputFields if not null',inputFields)
        // }else{
        //     inputFields[e.target.id] = undefined;
        //     console.log('inputFields if null',inputFields)
            
        // }
          
        this.setState({
            optionInputFields : inputFields
        });
        // console.log('inputFields',inputFields)
        
    } 
    addCurrentOptionAnswers             = (id,key,narrative_text,parentQuestionId,required_input,sort_order,multiSelect,prefix,postfix,single_line_text,validation_rules,event) =>
    {   
        const optionId                  = id;
        const parent_question_id        = parentQuestionId;
        const optionIndex               = key;
        const questionId                = this.state.currentQuestion.id;
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;
        
        //this.validator
        this.validator.purgeFields();     // Checks if previous validations in object validator. 
        this.validator.hideMessages();    // hide validation messages page wide.

        // Show input field if reuried input 1
        this.setState({
            showInput:optionId
        })

        const answers       = new Array();
        let _narrativeText  = narrative_text;
        
        answers.push({
            option_id:optionId,
            multiSelect:multiSelect,
            single_line_text,
            prefix,postfix,
            question_id:questionId,
            sort_order:sort_order,
            narrative_text:_narrativeText,
            parent_question_id:parent_question_id,
            required_input:required_input,
            required_input_text:this.state.optionInputFields[optionId],
            validation_rules: validation_rules
        });
        //  console.log('at addCurrentOptionAnswers answer',answers)
        if(multiSelect){

            if(questionAnswers[currentQuestionIndex]===undefined || questionAnswers[currentQuestionIndex].length===0){

                questionAnswers[currentQuestionIndex]=[];
            }
            // console.log('questionAnswers',questionAnswers)

            if(id===optionId && !this.state.checkedItems.get(id)){
                questionAnswers[currentQuestionIndex] = [...questionAnswers[currentQuestionIndex],answers[0]];
            }else if(id===optionId && this.state.checkedItems.get(id)){
                questionAnswers[currentQuestionIndex] = questionAnswers[currentQuestionIndex].filter((item)=>{
                    return item.option_id !== id;
                })
            }

        }else{

        questionAnswers[currentQuestionIndex] = answers[0];

        }

        this.setState({
            questionAnswers : questionAnswers
        });

        var ref = this;

        if(multiSelect){
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }else{
            Object.values(this.state.currentQuestionOption).forEach(function(row,key)
            {
                ref.setState(prevState => ({

                        checkedItems: prevState.checkedItems.set(row.id,) }
                ));
            })
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }
    }

    addCurrentOptionAnswersForBoxes             = (id,key,narrative_text,parentQuestionId,required_input,sort_order,multiSelect,prefix,postfix,single_line_text,boxesArray) =>
    {
        const optionId                  = id;
        const parent_question_id        = parentQuestionId;
        const optionIndex               = key;
        const questionId                = this.state.currentQuestion.id;
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;

        // Show input field if reuried input 1
        this.setState({
            showInput:optionId
        })


        // const answers       = new Array();
        // let _narrativeText  = narrative_text;
        // _narrativeText.replace('<x>', this.state.optionInputFields[optionId]);
        // _narrativeText.replace('<title>', this.state.profileData.title);
        // _narrativeText.replace('<name>', this.state.profileData.first_name+" "+this.state.profileData.last_name);
        // answers.push({
        //     option_id:optionId,
        //     multiSelect:multiSelect,
        //     single_line_text,
        //     prefix,postfix,
        //     question_id:questionId,
        //     sort_order:sort_order,
        //     narrative_text:narrative_text,
        //     parent_question_id:parent_question_id,
        //     required_input:required_input,
        //     required_input_text:this.state.optionInputFields[optionId],
        // });

        questionAnswers[currentQuestionIndex] = boxesArray;

        //
        // if(multiSelect){
        //
        //     if(questionAnswers[currentQuestionIndex]===undefined || questionAnswers[currentQuestionIndex].length===0){
        //
        //         questionAnswers[currentQuestionIndex]=[];
        //     }
        //
        //     if(id===optionId && !this.state.checkedItems.get(id)){
        //         questionAnswers[currentQuestionIndex] = [...questionAnswers[currentQuestionIndex],answers[0]];
        //     }else if(id===optionId && this.state.checkedItems.get(id)){
        //         questionAnswers[currentQuestionIndex] = questionAnswers[currentQuestionIndex].filter((item)=>{
        //             return item.option_id !== id;
        //         })
        //     }
        //
        // }else{
        //
        //     questionAnswers[currentQuestionIndex] = boxesArray;
        //
        // }


        this.setState({
            questionAnswers : questionAnswers
        });

        var ref = this;

        if(multiSelect){
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }else{
            Object.values(this.state.currentQuestionOption).forEach(function(row,key)
            {
                ref.setState(prevState => ({

                        checkedItems: prevState.checkedItems.set(row.id,) }
                ));
            })
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }
    }
    
    
    updateCurrentQuestion   = (index) => 
    {   
        
        const currentQuestion   = this.state.questionData[index];
        const questionOption    = this.state.questionData[index].options;
        const is_multiselect = isTrueOrFalse(this.state.questionData[index].is_multiselect);
        const prefix  = currentQuestion.prefix;
        const postfix= currentQuestion.postfix;

        const boxesArray=[];

        if(currentQuestion.is_image==="image_only"){

            Object.values(currentQuestion.options).forEach((item,key)=>{

                if(item.image_options!==null){
                boxesArray.push(item.image_options);
                }
            })
        }

        this.setState({
            currentQuestionIndex:index,
            currentQuestion: currentQuestion,
            currentQuestionOption: questionOption,
            is_multiselect,
            prefix:prefix,postfix:postfix,
            is_image:currentQuestion.is_image,
            boxesArray

        });

        setTimeout(()=>{

            this.checkAndMarkBoxes();

        },500)
        
    }
    displayInputText = (id)=>
    {
        return this.state.optionInputFields[id];
    }

    makeSeletedItemList=(selectedArray)=>{
        if (selectedArray === undefined || selectedArray.length == 0) {
            return null;
        }else {
            return (selectedArray.map((item) => {
                return (<div className="point-close"><div>{item.image_options.label}</div>
                    <span onClick={(event) => {
                        $(".marker" + item.label).remove();
                        // this.setState({
                        //     ...this.state, selectedLocation: this.state.selectedLocation.filter((i) => {
                        //         return item.id !== i.id;
                        //     })
                        // });
                    }}>&#10060;</span></div>)
            }));
        }
    };

    showPoints(pointsArray) {
        for (var i = 0; i < pointsArray.length; i++) {

            let found=false;

            if(this.state.questionAnswers[this.state.currentQuestionIndex]!=null && Array.isArray(this.state.questionAnswers[this.state.currentQuestionIndex])
            && this.state.questionAnswers[this.state.currentQuestionIndex].length>0){

                Object.values(this.state.questionAnswers[this.state.currentQuestionIndex]).forEach((item,key)=>{

                    if(item.id === pointsArray[i].option_id){

                        found=true;
                    }

                });
            }

            var topPercent = pointsArray[i].top;
            var leftPercent = pointsArray[i].left;
            var isChecked = found ? 'checked' : '';
            $('.js-point-img-container').append('<div style="top: ' + topPercent + '%; left: ' + leftPercent + '%;" class="img-point">\
            <input '+ isChecked +' type="checkbox" value="' + pointsArray[i].option_id + '" id="point-id-' + i + '" name="points" >\
            <label for="point-id-' + i + '"><span>Point</span></label>\
        </div>');
        }
    }

    handleOnClickPoint=(event)=>{

        // console.log("ITSCLICKED");

    };

  render() {
      var style = {
          'minWidth':'100%',
          'width':'auto',
      }
    return (
        <React.Fragment>
            <Header title="Interview Questions" titleImage="ic-conversation.png" />
            <Menu />
            <section className="chief-complain sec--question">
                {/* <div className="banner" >
                    <img src={require("../assets/img/bg/new-banner-question.jpg")} style={style} alt="" />
                </div> */}
                <div className="questionrow">
                    <div className="question">
                        <label>Question</label>
                        <h3>{this.state.currentQuestion.name}</h3>
                    </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    {
                      this.state.isLoading!=0 &&
                      <Loader/>
                    }
                </div>

                

                    <div className="content">
                    <div className="multybgRow">

                        {this.state.currentQuestion.is_image === "image_only" ?
                            <div className="container">
                                <div className="male-img">
                                    <section className="c-show-points-layout">
                                        <div className="point-img-wrapper js-point-img-container">
                                            <img id="boxespic" src={this.state.imgPath + this.state.currentQuestion.image_front} alt="Human Body"/>
                                        </div>
                                    </section>
                                </div>
                                <ul className="checkList">
                                {
                                    Object.values(this.state.currentQuestionOption).sort((a, b) => a.sort_order - b.sort_order).map((item, i) => (
                                        item.required_input == 1 ?
                                            <Check displayInputText={this.displayInputText}
                                                multiSelect={this.state.is_multiselect} validator={this.validator}
                                                validation_rules={item.required_input_rules}
                                                parent_question_id={item.parent_question_id}
                                                addInputTextInOptionAnswers={this.addInputTextInOptionAnswers}
                                                key={item.id} item={item} i={i}
                                                prefix={this.state.currentQuestion.prefix}
                                                postfix={this.state.currentQuestion.postfix}
                                                single_line_text={item.single_line_text}
                                                addCurrentOptionAnswers={this.addCurrentOptionAnswers}
                                                checked={this.state.checkedItems.get(item.id)}
                                                showInput={this.state.showInput}
                                                sort_order={this.state.currentQuestion.category_order}
                                            />
                                        : ''
                                    ))
                                }
                                </ul>
                            </div>
                            :
                            <ul className="checkList">
                                {

                                    Object.values(this.state.currentQuestionOption).sort((a, b) => a.sort_order - b.sort_order).map((item, i) => (
                                        <Check displayInputText={this.displayInputText}
                                               multiSelect={this.state.is_multiselect} validator={this.validator}
                                               validation_rules={item.required_input_rules}
                                               parent_question_id={item.parent_question_id}
                                               addInputTextInOptionAnswers={this.addInputTextInOptionAnswers}
                                               key={item.id} item={item} i={i}
                                               prefix={this.state.currentQuestion.prefix}
                                               postfix={this.state.currentQuestion.postfix}
                                               single_line_text={item.single_line_text}
                                               addCurrentOptionAnswers={this.addCurrentOptionAnswers}
                                               checked={this.state.checkedItems.get(item.id)}
                                               showInput={this.state.showInput}
                                               sort_order={this.state.currentQuestion.category_order}
                                        />

                                    ))}
                            </ul>
                        }
                    </div>
                </div>
            </section>
            
            <div className="sec-btn">
            
                <Link to="#" className="btn-img" onClick={this.updatePrevQuestion}>
                    <img src={require("../assets/img/icons/ic-prev.png")} alt="" />
                </Link>
            
            
            {
                (this.state.totalQuestion > 0 && this.state.currentQuestionIndex < this.state.totalQuestion) &&
                <Link to="#" className="btn-img " onClick={this.updateNextQuestion} >
                    <img src={require("../assets/img/icons/ic-next.png")} alt="" />
                </Link>
            }
                
            </div>

        </React.Fragment>
    );
  }
}

export default Questions;